import { injectable } from 'inversify';
import { observable } from 'mobx';

@injectable()
export class IosFocusStore {
    @observable hasFocus = false;

    private timeout: any;

    handleFocus = () => {
        clearTimeout(this.timeout);
        this.setValue(true);
    };

    handleBlur = () => {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this.setValue(false), 100);
    };

    private setValue(value: boolean) {
        if (navigator.userAgent.indexOf('iPhone') >= 0 && value !== this.hasFocus) {
            this.hasFocus = value;
        }
    }
}
